import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CmsUrl, SubFooterLink } from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { RichTextLinkComponent } from '../rich-text-link/rich-text-link.component';

@Component({
  selector: 'digital-platform-sub-footer-link',
  standalone: true,
  imports: [CommonModule, RichTextLinkComponent],
  templateUrl: './sub-footer-link.component.html',
  styleUrls: ['./sub-footer-link.component.scss'],
})
export class SubFooterLinkComponent
  extends BasePTypeComponent
  implements SubFooterLink
{
  public override type = 'subFooterLink' as const;

  @Input() url: CmsUrl = [];
  @Input() aTarget = '';
  @Input() anchorTarget = '';
  @Input() padding = '';
  @Input() paddingBottom = '';
  @Input() paddingHorizontal = '';
  @Input() paddingLeft = '';
  @Input() paddingRight = '';
  @Input() paddingTop = '';
  @Input() paddingVertical = '';
}
